import script from "./adjustments-sidebar-select.vue?vue&type=script&lang=ts&setup=true"
export * from "./adjustments-sidebar-select.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__